import {useFormContext} from "react-hook-form";
import {FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage} from "@/components/ui/form.tsx";
import {Input} from "@/components/ui/input.tsx";
import FormHeader from "@/components/booking/FormHeader.tsx";
import {z} from "zod";
import {BookingFormSchema} from "@/components/booking/form/BookingFormSchema.ts";
import {useContext} from "react";
import {OscarContext, OscarContextType} from "@/components/context/OscarContext.tsx";

export function PersonalInfoForm() {
    const {control} = useFormContext<z.infer<typeof BookingFormSchema>>();
    const { localConfig } = useContext(OscarContext) as OscarContextType

    return (
        <div className={"os-app-row os-grid os-grid-cols-1 md:os-grid-cols-2 os-gap-4"}>
            <FormHeader>
                Personal Information
            </FormHeader>
            <FormField
                control={control}
                name="firstName"
                render={({field}) => (
                    <FormItem>
                        <FormLabel>{ localConfig.communityBooking ? "Client/Tenant First Name" : "First Name" }</FormLabel>
                        <FormControl>
                            <Input autoComplete={"given-name"} required={true} placeholder={ localConfig.communityBooking ? "Client/Tenant First Name" : "First Name" } {...field} />
                        </FormControl>
                        <FormMessage/>
                    </FormItem>
                )}
            />
            <FormField
                control={control}
                name="lastName"
                render={({field}) => (
                    <FormItem>
                        <FormLabel>{ localConfig.communityBooking ? "Client/Tenant Last Name" : "Last Name" }</FormLabel>
                        <FormControl>
                            <Input autoComplete={"family-name"} required={true} placeholder={ localConfig.communityBooking ? "Client/Tenant Last Name" : "Last Name" } {...field} />
                        </FormControl>
                        <FormMessage/>
                    </FormItem>
                )}
            />
            <FormField
                control={control}
                name="email"
                render={({field}) => (
                    <FormItem>
                        <FormLabel>{ localConfig.communityBooking ? "Client/Tenant Email" : "Email" }</FormLabel>
                        <FormControl>
                            <Input autoComplete={"email"} type={"email"} required={true} placeholder={ localConfig.communityBooking ? "Client/Tenant Email" : "Email" } {...field} />
                        </FormControl>
                        { !localConfig.communityBooking && (
                            <FormDescription>
                                This is where we will send your booking confirmation and invoice.
                            </FormDescription>
                        )}
                        <FormMessage/>
                    </FormItem>
                )}
            />
            <FormField
                control={control}
                name="phone"
                render={({field}) => (
                    <FormItem>
                        <FormLabel>{ localConfig.communityBooking ? "Client/Tenant Phone" : "Phone" }</FormLabel>
                        <FormControl>
                            <Input autoComplete={"tel"} type={"tel"} required={true} placeholder={ localConfig.communityBooking ? "Client/Tenant Phone" : "Phone" } {...field} />
                        </FormControl>
                        { !localConfig.communityBooking && (
                            <FormDescription>
                                If we have any questions about your booking we will contact you on this number, we will also send you a booking confirmation and reminders about your booking.
                            </FormDescription>
                        )}
                        <FormMessage/>
                    </FormItem>
                )}
            />
            <FormHeader>
                Additional Information
            </FormHeader>
            <FormField
                control={control}
                name="businessName"
                render={({field}) => (
                    <FormItem>
                        <FormLabel>Business Name (Optional)</FormLabel>
                        <FormControl>
                            <Input autoComplete={"organization"} placeholder={ "Business Name (Optional)" } {...field} />
                        </FormControl>
                        <FormDescription>
                            This business name will be listed on your invoice.
                        </FormDescription>
                        <FormMessage/>
                    </FormItem>
                )}
            />
            <FormField
                control={control}
                name="poNumber"
                render={({field}) => (
                    <FormItem>
                        <FormLabel>P.O Number (Optional)</FormLabel>
                        <FormControl>
                            <Input placeholder="P.O Number (Optional)" {...field} />
                        </FormControl>
                        <FormDescription>
                            This P.O number will be listed on your invoice.
                        </FormDescription>
                        <FormMessage/>
                    </FormItem>
                )}
            />
        </div>
    )
}